import { render } from "./constrapage.vue?vue&type=template&id=0922267a&scoped=true"
import script from "./constrapage.vue?vue&type=script&lang=js"
export * from "./constrapage.vue?vue&type=script&lang=js"

import "./constrapage.vue?vue&type=style&index=0&id=0922267a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0922267a"]])

export default __exports__